export function setupHeader(): void {
    // Shrink fixed header on scroll
    $(window).on('scroll', function () {
        if ($(window).scrollTop()! > 100) {
            $('.header-fixed .header').addClass('header-fixed-shrink');
        } else {
            $('.header-fixed .header').removeClass('header-fixed-shrink');
        }
    });

    // Back to top
    const toTopBtn = document.querySelector<HTMLElement>('.back-to-top');
    if (toTopBtn) {
        toTopBtn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
}
